/**
 * Albero di navigazione dell'area riservata.
 * Allineato allo schema Directus: CustomerGoal, Appointment, Diet, HealthRecord,
 * MedicalReport, MentalRecord, NutritionRecord, SportRecord, TrainingPlan, Order, Form.
 */
export interface NavItem {
	label: string;
	path: string;
	icon?: string;
	/** Chiave schema/collezione di riferimento (es. appointments, customer_goals) */
	schema?: string;
	children?: NavItem[];
}

export type AreaRiservataSection = 'home' | 'appuntamenti' | 'my-focus' | 'profilo';

/** Sezioni principali della tab bar (primo livello) */
export const TABBAR_SECTIONS: { path: string; label: string; icon: string; section: AreaRiservataSection }[] = [
	{ path: '/area-riservata', label: 'Dashboard', icon: 'dashboard', section: 'home' },
	{ path: '/area-riservata/appuntamenti', label: 'Calendario', icon: 'event', section: 'appuntamenti' },
	{ path: '/area-riservata/my-focus', label: 'My Focus', icon: 'track_changes', section: 'my-focus' },
	{ path: '/area-riservata/profilo', label: 'Profilo', icon: 'person', section: 'profilo' },
];

/**
 * Albero completo di navigazione per ogni sezione.
 * Le sottosezioni placeholder sono state rimosse; la navigazione usa solo le 4 sezioni principali (tab bar).
 */
export const AREA_RISERVATA_NAV_TREE: Record<AreaRiservataSection, NavItem[]> = {
	home: [],
	appuntamenti: [],
	'my-focus': [],
	profilo: [],
};

/** Codici path per i percorsi My Focus (collection paths in Directus) */
export const MY_FOCUS_PATH_CODES = ['health_path', 'nutrition_path', 'fitness_path', 'mental_path'] as const;
export type MyFocusPathCode = (typeof MY_FOCUS_PATH_CODES)[number];

/** Mappa route segment (path) → code della collection paths */
export const MY_FOCUS_ROUTE_TO_PATH_CODE: Record<string, MyFocusPathCode> = {
	'/area-riservata/my-focus/salute': 'health_path',
	'/area-riservata/my-focus/nutrizione': 'nutrition_path',
	'/area-riservata/my-focus/fitness': 'fitness_path',
	'/area-riservata/my-focus/psicoterapia': 'mental_path',
};

/** Restituisce il path code per una route My Focus (es. /area-riservata/my-focus/salute → health_path) */
export function getPathCodeFromMyFocusRoute(routePath: string): MyFocusPathCode | null {
	const normalized = routePath.replace(/\/$/, '');
	return MY_FOCUS_ROUTE_TO_PATH_CODE[normalized] ?? null;
}

/** Restituisce la sezione tab bar in base al path */
export function getSectionFromPath(path: string): AreaRiservataSection {
	if (path === '/area-riservata' || path === '/area-riservata/') return 'home';
	if (path.startsWith('/area-riservata/appuntamenti')) return 'appuntamenti';
	if (path.startsWith('/area-riservata/my-focus')) return 'my-focus';
	if (path.startsWith('/area-riservata/profilo')) return 'profilo';
	return 'home';
}
